import { jsx as _jsx } from "react/jsx-runtime";
import { MessageBar, MessageBarType } from '@fluentui/react';
/**
 * The messagebar for the 5-point feedback UI
 */
export const FeedbackFivePointMessageBar = ({ onDismissFreeform, children, }) => (_jsx(MessageBar // eslint-disable-line jsx-a11y/role-supports-aria-props
, Object.assign({ messageBarIconProps: {
        iconName: 'Telemarketer',
    }, messageBarType: MessageBarType.success, onDismiss: onDismissFreeform, dismissButtonAriaLabel: 'Dismiss', 
    // We are only using the MessageBar's look and feel, this isn't actually
    // a message or alert that would need to interrupt a screen reader.
    // The aria and role should be set to the default values for a div here.
    // This prevents it from interrupting other content.
    role: 'none', "aria-live": 'off' }, { children: children })));
